import type { StripeInvoice } from "./models.js";

/** Above FR VAT (20%) so a backdated charge still clears when the rate is unknown. */
const STRIPE_SUBSCRIPTION_VAT_RATE = 0.3;

/**
 * Ex-VAT monthly price × billing periods since `subscriptionStartDate` × VAT buffer.
 * The anchor day clamps to the last day of a short month (31 Jan → 29 Feb → 31 Mar → 30 Apr).
 */
export function stripeSubscriptionBalanceRequired(
  monthlyPriceExVat: number,
  subscriptionStartDate: Date,
  now = new Date(),
) {
  const anchorDay = subscriptionStartDate.getUTCDate();
  let periods = 1;
  for (let i = 1; ; i++) {
    const monthIndex = subscriptionStartDate.getUTCMonth() + i;
    const year = subscriptionStartDate.getUTCFullYear() + Math.floor(monthIndex / 12);
    const month = monthIndex % 12;
    const lastDay = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    const periodStart = Date.UTC(
      year,
      month,
      Math.min(anchorDay, lastDay),
      subscriptionStartDate.getUTCHours(),
      subscriptionStartDate.getUTCMinutes(),
      subscriptionStartDate.getUTCSeconds(),
      subscriptionStartDate.getUTCMilliseconds(),
    );
    if (periodStart > now.getTime()) break;
    periods += 1;
  }

  return monthlyPriceExVat * periods * (1 + STRIPE_SUBSCRIPTION_VAT_RATE);
}

export function hasStripeUnpaidInvoice(invoices: StripeInvoice[]) {
  return invoices.some((invoice) => {
    return invoice.status === "open" || invoice.status === "uncollectible";
  });
}
